module.exports = __webpack_public_path__ + "img/logo-azati.9d5bc284.svg";